import {AvatarPart, uid} from "../common";

export default new AvatarPart({
	defs: [

	],
	render () {
		return `

		`;
	},
	attrs: {

	},
});



// WEBPACK FOOTER //
// ./src/facial-hair/blank.js